import { ReactNode } from 'react';

export interface DataHighlightItem {
	label: string;
	value: ReactNode;
}

/**
 * Center pane row with key dates / lifecycle stage / last activity — the
 * HubSpot "Data highlights" strip. Renders evenly-distributed cells with
 * small uppercase labels and emphasized values.
 */
export function DataHighlights({ items }: { items: DataHighlightItem[] }) {
	return (
		<div className="rounded-lg border bg-card">
			<div className="px-4 pt-3 pb-2 text-sm font-semibold">Data highlights</div>
			<div className="grid grid-cols-1 sm:grid-cols-3 gap-y-3 px-4 pb-4">
				{items.map((it, i) => (
					<div key={i} className="space-y-1 text-center sm:text-left">
						<div className="text-[10px] font-medium uppercase tracking-wide text-muted-foreground">{it.label}</div>
						<div className="text-sm font-medium text-foreground">{it.value || <span className="text-muted-foreground italic">—</span>}</div>
					</div>
				))}
			</div>
		</div>
	);
}
